import { gql } from '@apollo/client';

export const DELETE_OBJECTS_MUTATION = gql`
  mutation DeleteObjectsMutation($ids: [String!]!) {
    deleteObjects(ids: $ids) {
      ... on DeleteObjectsSuccess {
        deletedCount
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
